import classnames from 'classnames/bind'
import { useRef } from 'react'
// components
import Icon from '@/assets/icons'

import styles from './style.module.scss'
const cx = classnames.bind(styles)

type FollowHeartProps = {
  isActive?: boolean
  className?: string
  onClick?: () => void
  forceChangeOnClick?: boolean
  theme?: 'black' | 'white'
  showMask?: boolean
}
const FollowHeart = ({ className, isActive, onClick, forceChangeOnClick = false, theme = 'black', showMask = false }: FollowHeartProps) => {
  const heartDOMRef = useRef<HTMLParagraphElement | null>(null)
  const handleStringToBoolean = (value: string | null | undefined) => {
    if (value === 'true') {
      return true
    }
    if (value === 'false') {
      return false
    }
    return false
  }
  const handleIconClick = (event: React.MouseEvent<HTMLParagraphElement>) => {
    event.stopPropagation()
    onClick && onClick()
    if (forceChangeOnClick) {
      const currentIsActive = heartDOMRef.current?.getAttribute('data-is-active')
      const newIsActive = !handleStringToBoolean(currentIsActive)
      heartDOMRef.current?.setAttribute('data-is-active', String(newIsActive))
    }
  }

  return (
    <div>
      <p className={cx('follow-heart', className)} data-is-active={isActive} onClick={handleIconClick} ref={heartDOMRef}>
        {theme === 'black' ? <Icon.Follow /> : <Icon.Follow_White />}
      </p>
      {showMask && <div className={cx('image-mask-lower')} />}
    </div>
  )
}
export default FollowHeart
